import Image from 'next/image';
import { useRouter } from 'next/router';
import React, { useCallback } from 'react';
import ReactMarkdown from 'react-markdown';
import { HeroStyle } from '../../styles/components/home';
import { Button, HighlightedTitle } from '../common/ui';

export interface IHeroComponentProps {
  title: string;
  description: string;
  buttonLabel?: string;
  buttonPath?: string;
  buttonAction?: () => void;
  secondaryButtonLabel?: string;
  secondaryButtonPath?: string;
  secondaryButtonAction?: () => void;
  buttonStyle?:
    | 'primary'
    | 'secondary'
    | 'minimal'
    | 'minimal-secondary'
    | 'minimal-small'
    | 'cta'
    | 'tertiary'
    | 'outline'
    | 'outline-small'
    | 'subtle-small';
  backgroundUrl: string;
  backgroundAlt: string;
  titleTagName?: string;
  titleHighlightedText?: string | undefined;
}

const Hero = (props: IHeroComponentProps) => {
  const router = useRouter();
  const Tag = props.titleTagName || 'h1';
  const getTitle = useCallback(() => {
    return !!props.titleHighlightedText ? (
      <HighlightedTitle
        text={props.title}
        highlightedText={props.titleHighlightedText}
        headingTagName={props.titleTagName}
      />
    ) : (
      React.createElement(Tag, {}, props.title)
    );
  }, [Tag, props.title, props.titleHighlightedText, props.titleTagName]);

  return (
    <>
      <section>
        <header className={HeroStyle.hero}>
          <div className={HeroStyle['contentLeft']}>
            <div className={HeroStyle['text']}>
              {getTitle()}
              <ReactMarkdown>{props.description}</ReactMarkdown>
            </div>
            {!!props.buttonLabel && (
              <div className={HeroStyle['buttonWrapper']}>
                <Button
                  disabled={false}
                  color="tertiary"
                  onClick={() => {
                    if (props.buttonAction) {
                      props.buttonAction();
                    } else if (props.buttonPath) {
                      router.push(props.buttonPath);
                    }
                  }}>
                  {props.buttonLabel}
                </Button>
                {!!props.secondaryButtonLabel && (
                  <Button
                    disabled={false}
                    color="outline"
                    onClick={() => {
                      if (props.secondaryButtonAction) {
                        props.secondaryButtonAction();
                      } else if (props.secondaryButtonPath) {
                        router.push(props.secondaryButtonPath);
                      }
                    }}>
                    {props.secondaryButtonLabel}
                  </Button>
                )}
              </div>
            )}
          </div>
          <div className={HeroStyle['contentRight']}>
            <div className={HeroStyle['image-container']}>
              <Image
                quality={100}
                alt={props.backgroundAlt || props.title}
                src={props.backgroundUrl}
                priority
                fill
                sizes="(max-width: 768px) 100vw, 2000px"
              />
            </div>
          </div>
        </header>
      </section>
    </>
  );
};

export default Hero;
